import { VersionResponseSchema } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/health.ts` version endpoint. */
export const healthContract = {
    getVersion: {
        method: 'GET',
        path: '/health/version',
        response: VersionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to fetch version',
    },
};
//# sourceMappingURL=health.contract.js.map